import {promises} from "fs";
import {exec} from "../../electron/common/api";
import AsyncLimit from "../common/AsyncLimit";
import hdapi from "../common/hdapi";
import {cutFile} from "../common/utils";
import {
	checkIsCompressOver,
	getTaskDownloadUrl,
	getTaskStatus,
	upload,
	uploadAll,
	uploadVerify,
} from "../plugins/sdk";
import {getNowTimestamp, getTimestamp, getUUID} from "../plugins/sdk/common/utils";
import Converter, {ConverterStates} from "./Converter";
import ExceededWarn from "../pages/dialogs/ExceededWarn";

export default class ImageConverter extends Converter {
	constructor() {
		super();
		this._queue = new AsyncLimit(3);
		this.options = {
			compressLevel: 2, // 0: 缩小优先 1:清晰优先 2:标准压缩
			outputExt: "", // '':格式不变 png|jpg 其它格式
		};
		this._isExcededDolgOpen = false;
		this._ysType = "PDF压缩";
	}
	loadFile(path, isAFilePush, url) {
		// console.log("获取的word地址");
		return super.loadFile(path).then((file) => {
			// console.log("loadfile word =", res);
			// console.log(typeof file);
			if (isAFilePush) {
				file.isAFilePush = isAFilePush;
				file.OriginFilePushPath = url;
			}
			if (file.size) {
				file.state = ConverterStates.WAIT;
			} else {
				file.state = ConverterStates.BROKE_FILE;
			}
			return file;
		});
	}
	async doConvert(file, dir, i) {
		if (i == null) {
			i = "";
			file.filename = hdapi.filename(file.path);
		}
		// console.log("压缩第", i, "次");
		var ext = this.options.outputExt;
		var quality, compress_level, compress_text;
		switch (this.options.compressLevel) {
			case 0:
				compress_level = 2;
				quality = 20;
				compress_text = "condense";
				break;
			case 1:
				compress_level = 0;
				quality = 60;
				compress_text = "clarity";
				break;
			case 2:
				compress_level = 1;
				quality = 40;
				compress_text = "normal";
				break;
		}
		// console.log("quality", quality);
		ext = ext ? "." + ext : hdapi.extname(file.path);
		if (i == "") {
			// console.log("nowFileArry_1", this.nowFileArry);
			if (this.nowFileArry.indexOf(file.filename) == -1) {
				this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_2", this.nowFileArry);
			} else {
				var a = hdapi.extname(file.path).split(".");
				file.filename += `-` + a[1];
				this.checkIsSameFileName(file);
				// this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_3", this.nowFileArry);
			}
			var outfile = file.filename + ext;
		} else {
			var b = file.filename + `-${i}`;
			this.nowFileArry.push(b);
			console.log("nowFileArry_4", this.nowFileArry);
			var outfile = b + ext;
		}
		if (outfile.indexOf("[") >= 0) {
			console.log("进行转换1", outfile);
			outfile = outfile.split("[");
			console.log("进行转换2", outfile);
			outfile = outfile.join("【");
			console.log("进行转换3", outfile);
		}
		if (outfile.indexOf("]") >= 0) {
			console.log("进行转换1", outfile);
			outfile = outfile.split("]");
			console.log("进行转换2", outfile);
			outfile = outfile.join("】");
			console.log("进行转换3", outfile);
		}
		// console.log("outfile", outfile);
		if (file.isAFilePush) {
			if (window.store.local.outputOriginDir) {
				file.outpath = hdapi.join(file.outputOriginDir, outfile);
			} else {
				file.outpath = hdapi.join(file.outputCustomDir, outfile);
			}
			// return;
		} else file.outpath = hdapi.join(dir, outfile);
		// console.log("file.outpath", file.outpath);
		let exist = await hdapi.exists(`${file.outpath}`);
		if (exist) {
			await this.doConvert(file, dir, i == "" ? 1 : ++i);
		} else {
			// eslint-disable-next-line no-constant-condition
			if (hdapi.platform == "MAC" || !window.vue.$app.isNet) {
				file.onlineCompressStep = 0;
				file.CompressStyle = "online";
				file.isStopCompress = false;
				this.setTimeCheckProgress(file);
				var postdata = {
					tasktype: "pdfcompress",
					limitsize: 2048,
					filename: hdapi.filename(file.path) + hdapi.extname(file.path),
					filecount: 1,
					isshare: 0,
					// timestamp: await getTimestamp(),
					softname: "CompressMagician",
					softversion: window.$softInfo.version,
					machineid: getUUID(),
					productid: 133,
					filesrotate: 0,
					filesequence: 0,
					picturequality: compress_text, //清晰：clarity	常规：normal缩小：condense
					// outputfileextension: "jpg",
				};
				if (window.store.VIPlevel) {
					postdata.account = window.store.local.userLoginData.username;
					postdata.usertoken = window.store.local.userLoginData.usertoken;
				}
				// console.log("postdata", postdata);
				let res = await uploadVerify(postdata, file);
				if (res == "ExceedeTimes" && !this._isExcededDolgOpen) {
					// reject("exceededwarn")
					// debugger
					this._isExcededDolgOpen = true;
					let _this = this;
					await window.store.$dlg.show(ExceededWarn).then(() => {
						return Promise.reject("err");
					});
				}
				// console.log("请求上传文件权限获取成功", res);
				file.onlineCompressStep = 1;
				file.upload_data = res;
				file.chunksList = [];
				await cutFile(file, 2048000);
				file.onlineCompressStep = 2;
				console.log("切片结束返回");
				let b = await uploadAll(file, file.upload_data, 0);
				file.onlineCompressStep = 3;
				// console.log(res);
				if (b == "上传结束") {
					const c = await checkIsCompressOver(file);
					console.log("c", c);
				}
			} else if (hdapi.platform == "WIN") {
				// console.log("路径", `${main_path}\\bin\\comressfile\\output`);
				var ini_path;
				if (file.isAFilePush) {
					if (window.store.local.outputOriginDir) {
						ini_path = `${file.outputOriginDir}\\${hdapi.filename(file.path)}.ini`;
					} else {
						ini_path = `${file.outputCustomDir}\\${hdapi.filename(file.path)}.ini`;
					}
					// return;
				} else ini_path = `${dir}\\${hdapi.filename(file.path)}.ini`;
				// console.log("wordini路径", ini_path);
				var handle_time = file.size / 1024 / 1024 < 2 ? 10 : 1e2;
				var handle = setInterval(function () {
					// console.log("是否监听到文件", ini_path);
					hdapi
						.readFile(ini_path, "utf8")
						.then((text) => {
							var ss = text.split("progress=");
							var p = parseFloat(ss[ss.length - 1].split("\n")[0] / 100);
							// console.log("读取到的ini文件", p);
							// // console.log("ss", p);
							if (!isNaN(p)) {
								file.progress = p;
							}
						})
						.catch((err) => {
							console.log("读取文件遇到问题", err);
						});
				}, handle_time);
				// console.log("开始word压缩", `CompressFile "${file.path}" "${file.outpath}" ${quality}`);
				return hdapi
					.procCreate(
						[`PdfCompressProcess.exe`, file.path, file.outpath, ini_path, compress_level, quality],
						{spawnMode: true}
					)
					.then((x) => {
						file._proc = x;
						return x.wait();
					})
					.finally(() => {
						console.log("压缩结束");
						clearInterval(handle);
						hdapi.unlink(ini_path);
					});
			}
		}
	}
	setTimeCheckProgress(file) {
		file.nowInterval_step = file.onlineCompressStep;
		file.nowInterval_limit = 0.1;
		file.progress = 0;
		file.progress_time = setInterval(function () {
			// console.log("progress", file.progress);
			if (file.state != 2) {
				file.progress = 0;
				clearInterval(file.progress_time);
				return;
			}
			if (file.nowInterval_step != file.onlineCompressStep) {
				switch (file.onlineCompressStep) {
					case 0: {
						file.progress = 0;
						file.nowInterval_limit = 0.1;
						break;
					}
					case 1: {
						file.progress = 0.1;
						file.nowInterval_limit = 0.2;
						break;
					}
					case 2: {
						file.progress = 0.2;
						file.nowInterval_limit = 0.3;
						break;
					}
					case 3: {
						file.progress = 0.3;
						file.nowInterval_limit = 0.8;
						break;
					}
					case 4: {
						file.progress = 0.8;
						file.nowInterval_limit = 0.9;
						break;
					}
					case 5: {
						file.progress = 0.9;
						file.nowInterval_limit = 1;
						break;
					}
					case 6: {
						file.progress = 1;
						file.nowInterval_limit = 1;
						break;
					}
				}
				file.nowInterval_step = file.onlineCompressStep;
			}
			if (file.progress < 0.8 && file.progress < file.nowInterval_limit) file.progress += 0.01;
		}, 50);
	}

	checkIsSameFileName(file, i) {
		if (!i) i = 1;
		if (this.nowFileArry.indexOf(file.filename) == -1) {
			this.nowFileArry.push(file.filename);
			return;
		} else {
			file.filename = file.filename + `(${i})`;
			this.checkIsSameFileName(file, i);
		}
	}
}
